// extracted by mini-css-extract-plugin
export default {"card":"k0-z","carouselContainer":"l0-z","carouselContent":"m0-z"};